import { AutogenModelLogisticsControl, AutogenRowLogisticsControl } from "./autogen/AutogenModelLogisticsControl";

export class ModelLogisticsControl extends AutogenModelLogisticsControl<RowLogisticsControl> {
	constructor() {
		super(RowLogisticsControl);
	}
}

export class RowLogisticsControl extends AutogenRowLogisticsControl {
}